export const ROUTE_NAME = {
  COMPOSE: "message-compose",
  EDIT_COMPOSE: "editCompose",
  CREATE_QUICK_ACTIONS: "createQA",
  SMART_GROUPS: "groups",
  SMART_GROUP_MEMBER: "smartGroupMember",
  TEMPLATES: "templates",
  EDIT_TEMPLATE: "editTemplate",
  EDIT_VIEWED_TEMPLATE: "editViewedTemplate",
  ADD_TEMPLATE: "addTemplate",
  TEMPLATE_DETAILS: "templateDetails",
  ACCOUNT_MANAGEMENT: "account-management",
  CONTACTS: "contacts",
  EDIT_CONTACT_FILTER_MEMBERS: "editContactFilterMembers",
  EDIT_CONTACT_FILTER: "editContactFilter",
  ADD_CONTACT_FILTER: "addContactFilter",
  CONTACT_GROUP_MEMBERS: "contactGroupMembers",
  ADD_CONTACT_GROUP_MEMBERS: "addContactGroupMembers",
  DIARY: "diary",
  SCHEDULE_MESSAGE: "scheduleNewMessage",
  QUEUE_MANAGER: "queue-manager",
  BULK_COMPOSE: "bulkCompose",
  BULK_JOB_DETAILS: "bulkJobDetails",
  DIVERTS: "diverts",
  ADD_DIVERT: "addDivert",
  DIVERT_PROFILE_MEMBERS: "divertProfileMember",
  QUICK_ACTIONS: "quick-actions",
  QUICK_SEND: "quick-send",
  MESSAGES: "messages",
  CAMPAIGN_MESSAGES: "campaign-messages",
  MESSAGES_CHARTS: "messagesCharts",
  MESSAGE_MEMBERS: "message-members",
  MESSAGE_NESTED_MEMBER: "nestedMembers",
  MESSAGE_MEMBER_DETAILS: "details",
  MESSAGE_EXPORTS: "export",
  SETTINGS: "settings",
  NOT_FOUND: "not-found",
  APP_MANAGEMENT: "app-management",
  CONVERSATIONS: "chats",
  CAMPAIGN_MANAGER: "campaign-manager",
  CAMPAIGN_SUBSCRIBERS: "campaign-subscribers",
  MESSAGES_NEW: "new-messages",
  MESSAGE_MEMBERS_NEW: "message-members-new",
  SEND_MESSAGE_TO_SUBSCRIBERS: "message-to-campaign-subscribers",
  SEND_MESSAGE_TO_CAMPAIGN: "message-to-campaign",
  PAGER_EVENTS: "pager-events",
  PAGER_EVENTS_HISTORY: "history",
};

export const SERVICE_NAME = {
  QUICK_ACTIONS: "quick-actions",
  MESSAGES: "messages",
  QUEUE_MANAGER: "queue-manager",
  CONTACTS: "contacts",
  SMART_GROUPS: "groups",
  DIARY: "diary",
  TEMPLATES: "templates",
  DIVERTS: "diverts",
  LOCATION: "location",
  ACCOUNT_MANAGEMENT: "account-management",
  SETTINGS: "settings",
  APP_MANAGEMENT: "app-management",
  CAMPAIGN_MANAGER: "campaign-manager-147",
  PAGER_EVENTS: "pager-events",
  PAGER_EVENTS_HISTORY: "history",
  QUICK_SENDS: "quick-sends",
};
